import "./Users.scss";

import upload from "../../assets/images/icons/upload.svg";
import sort from "../../assets/images/icons/sort.svg";
import edit from "../../assets/images/icons/edit-purple.svg";
import deleteIcon from "../../assets/images/icons/delete.svg";
import search from "../../assets/images/icons/Search.svg";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import ReactPaginate from "react-paginate";
import axios from "axios";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

const apiURL = process.env.API_URL;

function Users() {
    const navigate = useNavigate();

    const tabs = ["name", "birth day", "gender"];
    const headings = [
        "Name",
        "Birth day",
        "Location",
        "Gender",
        "Member since",
        "Last Active",
        "E-mail",
        "Phone",
        "Instagram",
        " ",
    ];
    const [searchQuery, setSearchQuery] = useState("");
    const [users, setUsers] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    //GETING INITIAL USERS =================================

    useEffect(() => {
        const getUsers = async () => {
            try {
                const response = await axios.get(`https://zona-app-server-584d567d8841.herokuapp.com/users`);
                setUsers(response.data);
                setDisplayUsers(response.data);
            } catch (error) {
                console.log(`users get request didn't work. error: ${error}`);
            }
        };
        getUsers();
    }, []);

    //SEARCH BAR ===========================================

    const handleChange = (event) => {
        setActiveSearch(true);
        setSearchQuery(event.target.value);

        const filtered = users.filter(
            (item) =>
                item.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.email.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.phone.includes(event.target.value)
        );
        setFilteredData(filtered);
        // console.log(filtered)
    };

    const [displayUsers, setDisplayUsers] = useState([]);
    const [activeSearch, setActiveSearch] = useState(false);

    useEffect(() => {
        activeSearch ? setDisplayUsers(filteredData) : setDisplayUsers(users);
    }, [activeSearch, filteredData, users]);

    function handleExitSearch() {
        setActiveSearch(false);
        setSearchQuery("");
    }

    //PAGINATION =========================================

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(10);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = displayUsers.slice(indexOfFirstPost, indexOfLastPost);

    const paginate = ({ selected }) => {
        setCurrentPage(selected + 1);
    };

    //SORTING ============================================

    const [nameSortClicks, setNameSortClicks] = useState(1);
    const [genderSortClicks, setGenderSortClicks] = useState(1);

    function handleSortClick(by) {
        switch (by) {
            case "name":
                setNameSortClicks((prevCount) => prevCount + 1);
                applyNameFilter();
                break;
            //STILL NEED TO INCLUDE BIRTHDAY SEARCH
            case "gender":
                setGenderSortClicks((prevCount) => prevCount + 1);
                applyGenderFilter();
                break;
            default:
                break;
        }
    }

    function applyNameFilter() {
        let filteredUsers;

        switch (nameSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayUsers].sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                filteredUsers = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayUsers].sort((a, b) => {
                    return b.name.localeCompare(a.name);
                });
                filteredUsers = sortedByNameZA;
                break;
            case 3:
                filteredUsers = users;
                setNameSortClicks(1);
                break;
            default:
                filteredUsers = users;
                break;
        }

        setDisplayUsers(filteredUsers);
    }

    function applyGenderFilter() {
        let filteredUsers;

        switch (genderSortClicks) {
            case 1:
                const sortedByGender = [...displayUsers].sort((a, b) => {
                    const genderOrder = {
                        Female: 1,
                        Male: 2,
                    };
                    return genderOrder[a.gender] - genderOrder[b.gender];
                });
                filteredUsers = sortedByGender;
                break;
            case 2:
                const sortedByGenderMF = [...displayUsers].sort((a, b) => {
                    const genderOrder = {
                        Male: 1,
                        Female: 2,
                    };
                    return genderOrder[a.gender] - genderOrder[b.gender];
                });
                filteredUsers = sortedByGenderMF;
                break;
            case 3:
                filteredUsers = users;
                setGenderSortClicks(1);
                break;
            default:
                filteredUsers = users;
                break;
        }

        setDisplayUsers(filteredUsers);
    }

    //DELETING USER =====================================

    const [deleteModal, setDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState({});

    function handleDeleteUser(user) {
        setDeleteModal(true);
        setUserToDelete(user);
    }

    function handleDelete(id) {
        const deleteUser = async () => {
            try {
                await axios.delete(`https://zona-app-server-584d567d8841.herokuapp.com/users/${id}`);
                setDeleteModal(false);
            } catch (err) {
                console.log(`failed to delete user. this is the error: ${err}`);
            }
        };

        deleteUser();
    }

    //EXPORTING DATA ===================================

    function handleExportDataClick() {
        try {
            const csvRows = [];
            // Extracting headers
            const headers = Object.keys(users[0]);
            csvRows.push(headers.join(","));

            // Extracting data rows
            for (const row of users) {
                const values = headers.map((header) => {
                    const escapedValue = row[header].toString().replace(/"/g, '\\"');
                    return `"${escapedValue}"`;
                });
                csvRows.push(values.join(","));
            }

            // Combine rows into CSV content
            const csvContent = csvRows.join("\n");

            // Convert CSV content to blob
            const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

            // Trigger download
            saveAs(csvBlob, "users_data.csv");
        } catch (error) {
            console.error("Error converting JSON to CSV:", error);
        }
    }

    //DATE FORMATTER ===================================

    // function dateFormatter(str) {
    //     const secondsSinceEpoch = parseInt(str.$timestamp.substring(0, 8), 16);

    //     const jsDate = new Date(secondsSinceEpoch * 1000);

    //     const month = String(jsDate.getMonth() + 1).padStart(2, '0');
    //     const day = String(jsDate.getDate()).padStart(2, '0');
    //     const year = jsDate.getFullYear();
    //     const formattedDate = `${month}/${day}/${year}`;

    //     return formattedDate;

    // }

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                {deleteModal && (
                    <DeleteModal
                        handleDelete={handleDelete}
                        setDeleteModal={setDeleteModal}
                        modToDelete={userToDelete}
                        tableName={"Users"}
                    />
                )}
                <article style={{ width: "100%", display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <section className="users">
                        <div className="users__top">
                            <h1 className="users__top-heading">Users</h1>
                            <div className="users__top-buttons">
                                <div className="users__top-buttons-search">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <label htmlFor="search">
                                            <img
                                                src={search}
                                                className="users__top-buttons-search-icon"
                                                alt="magnifying glass"
                                            ></img>
                                        </label>
                                        <input
                                            id="search"
                                            type="text"
                                            className="users__top-buttons-search-input"
                                            placeholder="Search..."
                                            value={searchQuery}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {activeSearch && (
                                        <div onClick={handleExitSearch} className="users__top-buttons-search-x">
                                            <p className="users__top-buttons-search-x-text">X</p>
                                        </div>
                                    )}
                                </div>
                                <Link to="/users/add" className="users__top-buttons-colorful">
                                    Add new user +
                                </Link>
                                <button onClick={handleExportDataClick} className="users__top-buttons-clear">
                                    Export data
                                    <img className="users__top-buttons-clear-icon" src={upload} alt="upload icon"></img>
                                </button>
                            </div>
                        </div>

                        <div className="users__sorts">
                            {tabs.map((tab, index) => (
                                <button
                                    onClick={() => handleSortClick(tab)}
                                    key={index}
                                    className="users__sorts-button"
                                >
                                    <p className="users__sorts-button-text">Sort by {tab}</p>
                                    <img className="users__sorts-button-icon" src={sort} alt="sort icon"></img>
                                </button>
                            ))}
                        </div>

                        <table className="users__table">
                            <thead className="users__table-top">
                                <tr className="users__table-top-headings">
                                    {headings.map((heading, index) => (
                                        <th key={index} className="users__table-top-headings-heading" scope="col">
                                            {heading}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody className="users__table-info">
                                {currentPosts?.map((user) => (
                                    <tr key={user._id} className="users__table-info-info">
                                        <td className="users__table-info-info-text">
                                            <Link to={`/users/${user.id}`} className="users__table-info-info-text-link">
                                                {user.firstName} {user.lastName}
                                            </Link>

                                            <img
                                                onClick={() => navigate(`/users/edit/${user.id}`)}
                                                src={edit}
                                                className="users__table-info-info-text-icon"
                                                alt="purple pen"
                                            ></img>
                                        </td>
                                        <td className="users__table-info-info-text">{user.bday ? user.bday : "-"}</td>
                                        <td className="users__table-info-info-text">{user.location}</td>
                                        <td className="users__table-info-info-text">{user.gender}</td>
                                        <td className="users__table-info-info-text">
                                            {/* {dateFormatter(user.created)} */}-
                                        </td>
                                        <td className="users__table-info-info-text">
                                            {user.lastActive ? user.lastActive : "-"}
                                        </td>
                                        <td className="users__table-info-info-text">{user.email}</td>
                                        <td className="users__table-info-info-text">{user.phone}</td>
                                        <td className="users__table-info-info-text">{user.ig}</td>
                                        <td className="users__table-info-info-text">
                                            <img
                                                onClick={() => handleDeleteUser(user)}
                                                src={deleteIcon}
                                                alt="purple garbage bin"
                                            ></img>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                    <div className="pagination-container">
                        <ReactPaginate
                            onPageChange={paginate}
                            pageCount={Math.ceil(displayUsers.length / postsPerPage)}
                            previousLabel={"<"}
                            nextLabel={">"}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            containerClassName={"pagination"}
                            pageLinkClassName={"page-number"}
                            previousLinkClassName={"page-number-prev"}
                            nextLinkClassName={"page-number-next"}
                            activeLinkClassName={"active-number"}
                        />
                    </div>
                </article>
            </div>
        </main>
    );
}

export default Users;
